import { ArrowLeft, ArrowRight } from "lucide-react";
import React, { useState } from "react";

const Photos = () => {
  const [index, setIndex] = useState(0);
  const images = [
    "/photos/001-14946827e1927a2c7856a05633855d6eb9a61e7854d89f3d839ec30d7333a5da.jpeg",
    "/photos/002-80bfffd93f56484d3e70a8d8d53c1497febd527652ff82b7c2a6b13ac4dd2cae.jpeg",
    "/photos/003-d5024b7025d22972d652df9e517ed241827cef497f7b08962ef58192d888cf82.jpeg",
    "/photos/004-5a33a95c83d8d2a6db85d2e55ca3f8abc83ec54d4c1331caa91185baa988caf5.jpeg",
    "/photos/005-d9cb5ca1988792964485bd3fda4424856adb1eeed69a13cd9d79d58ed993928c.jpeg",
    "/photos/006-90e1b119c6cef4d19026cf043a1b7abb45717007382a065bd54c4f7aadb1fb7e.jpeg",
    "/photos/007-0d6dbaf8b507ecfc2792f30f41386218d5823753574933e7e045332fd165f0cd.jpeg",
    "/photos/008-217584a6570d6d188cdb3ac7559e687c09d44cc640604ed77d03797a853df5fd.jpeg",
    "/photos/009-d9a916bdcead366d2c123e93f365ed43b233514753216493837bfe3a8b39e898.jpeg",
    "/photos/010-9c9c028fe68f7a11d413ccf7e29666fdf688c21d1ebc1b90136cf25dd369f71d.jpeg",
    "/photos/011-7a5f9596302fa586a2e1967f29767e25367719570471f68c11d85f65562a88b5.jpeg",
    "/photos/012-52ee1d6d519b2cfee58f855633542ef915477b55300d64867a55c6b54daf40b3.jpeg",
    "/photos/013-92915102dba11fc9134768059fe74c84582b12b9d5429f01c096380bfb4a5ba8.jpeg",
    "/photos/014-a96172e7f8bd2874f2ac77760aa529a9a714db2d666dbeb687407e556eff2e1f.jpeg",
    "/photos/015-958dc95431eb7d27ab094bf9dada4655dd36bf8b2c221c9743faabce47267cd0.jpeg",
    "/photos/016-e80f2b8e946f3556669241e3bb11b84d00c8edb15d90e2e23e31d5e8e8d0db00.jpeg",
    "/photos/017-e6f4fb2dccc42b52f5e5f5584ab7a6c552dc63a3e38b8c90b4fd2cdd7b3c6d2a.jpeg",
    "/photos/018-abd5f9f08a3232ec1efd8b6441a8e956db3df0ca26c98b6e8581c77abee4eddd.jpeg",
    "/photos/019-4d51d9b85fbaad39921222fafaeb132b6d8d5a7520f72c15ee0e87e13c2b307a.jpeg",
    "/photos/020-844aa9a1be764dbe4395f6efb7e8f8ee4ce17064137d0acc2fa00808d3e0b5f3.jpeg",
    "/photos/021-572ba62b8eb34f8511d4b509786910a41585d2b31f330a020e2a1061410b08b8.jpeg",
    "/photos/022-47e3ea4cb616b3b821fee72ff01d138caf299b51b2ed756c9fdcc6b263c9b97d.jpeg",
    "/photos/023-ae9d04db8540ba8b8df53a52ddec48512fe0a7fe22ab5d56392c2f135c8b617f.jpeg",
    "/photos/024-3858b9b6bfe95818faeb7074433b2c42339d67db42f6293aec3e15f82d415900.jpeg",
    "/photos/025-04abe2f3b1ea98b9dff62b457a90f3e5e4629c3d616ad8048775be92a7763652.jpeg",
    "/photos/026-34b9f918a1708a73767aaff7e7f37f6e92f00fabd5905ea132b13d2955f3ae76.jpeg",
    "/photos/027-2c0fc13382131429e83dac6cbbb12af237a91a2ec10e533fec0a775d2ecdef14.jpeg",
    "/photos/028-8c51681b59dddc6a25c483227c54a4118c80efc6a8278c108d670dec9f7e18ee.jpeg",
    "/photos/029-74714add0b216537177ed855683aa79acfa01c8e0eb80768b06aa4946ab8e5d1.jpeg",
    "/photos/030-4835fa6c34751f4fdcbae84e954728a40cef688e039bc71be82afb7bb311d818.jpeg",
    "/photos/031-f4de2e35a26a8138fb6d09f02bf318315895b74440b75bf0be8628846705b2f6.jpeg",
    "/photos/032-9a2d8437568791161a7178f45f7ab7497a6511e34e31d4e5c1ff0b7fcb9ade28.jpeg",
    "/photos/033-455ec24e03481291a61da5faa3f2d4109ef225ba49f0dbf3bae04951e82a1bfd.jpeg",
    "/photos/034-f973e9fb391063109732a409a3c8050ad8295fd75b9ea70b1ad8d0100833821e.jpeg",
    "/photos/035-4e1b17971fce590404edba0ec479b18ed9975fbe4afce2f7afe1402b3b844e88.jpeg",
    "/photos/036-4baf2556320c1fa5f549e136196f6eed70cb44717670357f659859b6e764ed06.jpeg",
    "/photos/037-c3bb5100a07cfb6aa023f70e8a4095ef98dc8848ed36e539089d8c6df8f07042.jpeg",
    "/photos/038-91e7fc48762cc6e3a0acb36452da9375bc0245bf49572ece2099e68d9f755e3b.jpeg",
    "/photos/039-7b2ae5caa9431b97cb376edd51ee3c9237984a79d19bab25f663bb5cd87ec40e.jpeg",
    "/photos/040-eae6746aeb492707a39fecb7701976118daca26377f9be533a3f4eaf126e8c44.jpeg",
    "/photos/041-ba7860b90144ef086f5ba96393549c130e0b21cc986980022943850a41d2503b.jpeg",
    "/photos/042-05c48094f0fa7c389059f886d9583d909ec67758caa20c86e42a823458bd3536.jpeg",
    "/photos/043-41b4917262e6a0acf155ae3f9b8fa14712286ddab962149f5c4844dc7813a789.jpeg",
    "/photos/044-ba4d9afccf1b439aabc2c139038d7564fe649b5f70805bf6faf069626551f98a.jpeg",
    "/photos/045-6592d8d5f2d4a714d33ae4a353a637ba6af98fb6354327b95d690a39f2db7dd5.jpeg",
    "/photos/046-a7f4ffa8f11b25463dccc342215cf896c3e094054727e20d5510e55f6492f4fc.jpeg",
    "/photos/047-1a9cc338779b7b126ae032fc7427175429b8e062a0073fe755f155de47fa2c4c.jpeg",
    "/photos/048-541b5c9979f4046ad067e941edd20fd94f316f2369c2186c2fb788c26221c248.jpeg",
    "/photos/049-4b282c0c580bb5b727c268c5764b16ae843da78dd0da358cdfdc3c395ce5dddf.jpeg",
    "/photos/050-475e9a4a11ff8e6648ba56988077fc17a5b263ab67fb6f22af10f98443a9259b.jpeg",
    "/photos/051-06a19dcb0b207a7b56d14a5e54d6c68b69b29f04c47029d7e8d8111736720452.jpeg",
    "/photos/052-9e1dc7833b1a676e11016ee81d3f0fa668d841a8734819a658366f2dca66a796.jpeg",
    "/photos/053-281047934d05295dda0fc3c7464fc239a1a7dc565a42f453c07c094e422565fe.jpeg",
    "/photos/054-f29e1d18b752439886db24e43743bb059086f56c4ec6a4cb3802496bb3283cf1.jpeg",
    "/photos/055-2177a91bd3ec6bb50ea34f5e971e3a8a302dc4dde23ab0ab095c619c413c6856.jpeg",
    "/photos/056-00633a9d28ac7d92c5b0325f364f32aa96ad9d1de4e6fbd0d55a59fb6f438e4e.jpeg",
    "/photos/057-b0b565b81dfc78aab58ea194cb72908afec4b580eaedfb0181c7b052a1782252.jpeg",
    "/photos/058-fe1e79888b7a336319e390f2802d4a3bfb87ffcd5c9a2152e3802d3e1c6effb7.jpeg",
    "/photos/059-491ed26f1fcc06914130be0680cbcf75edb9f715ba6b03f31dde01a1849b2478.jpeg",
    "/photos/060-4a249d7dc62d5695e61fed69abd8da5a933c4379f2c3ca2a2c51350335586286.jpeg",
    "/photos/061-80444f630b78cbc5af69dc5baee7633a03a5f0a7857e8e7eaba848dd9a0a7c08.jpeg",
    "/photos/062-54622ae7ffb816637be85eacc750ae1f68902b20db3b2d98305e16aa9105527d.jpeg",
    "/photos/063-a71662d539aaa704ec2c460f006e195fe77f26ed1def60f054d616d4f768e987.jpeg",
    "/photos/064-d5088d1aa28485e82cf990e463393f4a8b6da161ee2abc54f9a5e4cb217910ed.jpeg",
    "/photos/065-82a5ef1ad40e4c6a59c7afca77f70f5f466cfe84467606988e805af31c637c83.jpeg",
    "/photos/066-4dd44276ce276a6c032083ed5ae95875e83b5e55045e2487600225cb4112cbfb.jpeg",
    "/photos/067-4f4b432beb3892574d0bfdb48ba054950a9a3ab9f14bed88dd2d74761f62adf4.jpeg",
    "/photos/068-b843f823115ea2189345779111e104e2b325b075168fd865922be80bb0d2c2d2.jpeg",
    "/photos/069-54f2706b7c297e9a687285c2a3ca72ca2756d0415f7443bc493d22c1f6726951.jpeg",
    "/photos/070-29aac262a550e8f42214cad3b94ec39cd7becb5e7a12bfbef22d73cb23b9fb72.jpeg",
    "/photos/071-c50a10b13455e3b861539e395001ec72b86da2ccb98205297df46ca11b6a6b10.jpeg",
    "/photos/072-56a9a5fa770931463ade367f5ff6318e79e03c3681e1e47a9269624124b4b351.jpeg",
    "/photos/073-fd96a91110a7fd500c8652b3030d2ebb624ef97de5dd3eea12ec8b8ac1826a2a.jpeg",
    "/photos/074-44d4497400e1fd8b299e4c1c7b18cf6f95ec81c50265860011c09fe9e77922f3.jpeg",
    "/photos/075-28ba5aa7462c7de3c0e516a73a8b7fb3f61be62aa0ebb1907b124b7994d1fa23.jpeg",
    "/photos/076-b7763990d91e83c0185668bfac47043df229c302b524d8f8b3b65ec301fe85e1.jpeg",
    "/photos/077-5940581d29aa0938274b22526281185a1a9e2dce168e057a91889d4a96fe514a.jpeg",
    "/photos/078-c57dd2d306f576924a6a2b78377d9ac646f2661fa1146ed76503db90032325d0.jpeg",
    "/photos/079-ca787a20dece00aa17d0cf5f26c6e3a2461876db2d5a1e01b7fb395f3995b9ea.jpeg",
    "/photos/080-bc7b234c9a54dfed50885c3eba46245a11e1ed61b417cc6e516f25a9f8edd142.jpeg",
    "/photos/081-d99f272716dc8453b23839ce18555bb530a4d3d1211a545478d518e4d5c01a8b.jpeg",
    "/photos/082-ce3a1a6e99b5d3b9b12874d977bbb668eadc0c7e9aa7a4c81b5076405c4c322a.jpeg",
    "/photos/083-b700a60082c8e59e054738bd9f8ed14bb800bc0b1081ccdf8c244171e0ff706a.jpeg",
    "/photos/084-a9573bc7c15c2f5f5b59ba1ee0aa4b362c65123f1e72352d55e5ad282833b85c.jpeg",
    "/photos/085-8f28fe23e80ebbff108a049841d4a9e6f6bf9ed1594214968363acd9ccec54bf.jpeg",
    "/photos/086-b375b5d0ac7a8cdb2d638d120a9e18f18aa8770c826adf6e56ef60c53a3439f3.jpeg",
    "/photos/087-7f573b48f16c2b8936018c2f532412a411a0dc5f1e0435dda9ee02a38ec97e80.jpeg",
    "/photos/088-63c78109b9553a884010ee8cf6dffabd7af112955716df8df24e769ea2fa720a.jpeg",
    "/photos/089-38c99c80ceb07d463ad57f3b655de35a33c864b30153f4cb5990b74cf472890c.jpeg",
    "/photos/090-246ef61cb21b40bed591fc259e9a62b41e55b44d1fd6f902aabebaae1ef17486.jpeg",
    "/photos/091-15af2e176bad920b7fdcbc39ab90f2834aca4df22b0c9df4f7f4926021c86cbd.jpeg",
    "/photos/092-3294d5f81cc4293d32509bb73acc2319b05a94077a5e055487f27aa8d1f62069.jpeg",
    "/photos/093-ee86e4594522ba6571c5aeda76ead0c5219e9c9ce2d2e6eb9e8335987a4597ad.jpeg",
    "/photos/094-22ed92e4fdc42bc530a1a78b72efc91dc1907b14e78e7cbe3a687b526267ca50.jpeg",
    "/photos/095-6aef9b094fbf0461a20efef8456d8eef4bd339258678b6976dca572fe72ea04f.jpeg",
    "/photos/096-3e171b3eba2472ab46438718502fca14345cee5d15ea3c0035eca7f2da3428a3.jpeg",
    "/photos/097-661d80dd4d9c4ab0d94d789af382d73b6ae7f4725fa9b562a85cde918098f88f.jpeg",
    "/photos/098-0a29404b093e2f56646b7640ae29ba7582c6a332d30fa21f1adaec3ad0a0304c.jpeg",
    "/photos/099-2500b151cbcdda99c0764ed6fc5e50667ac3f6ba36dbc384eed1bdf90c76cb3b.jpeg",
    "/photos/100-f72dc203db9f75a351f91bd327d1c3378f6659e33b307c073994af809af3cf4f.jpeg",
    "/photos/101-ba757c11bf174d0a99973d89ec8148b92cf18ec22ba975d8770dc1ef36cca80e.jpeg",
    "/photos/102-e8584205f63b1a1dd945ae3dbfce7131fe70e3b067197aba118602fbebe638cb.jpeg",
    "/photos/103-a4c1feaecf23f8f01daf70f159f36565c2389b584a7e8db9c83651138dde87f6.jpeg",
    "/photos/104-7d6d3313f4a912306d3a6cbfe5296ed5f7debc4a0a27a94b1f6e3e351276140e.jpeg",
    "/photos/105-21a4425cd25f9f305aa1fe23c02c37a24b5c2a334dd4cad0a11d5bb5808851e9.jpeg",
    "/photos/106-32798c5735aebbbb8ebff4b589051ae5030bbe7cceee5776be7e3851c841a6f2.jpeg",
    "/photos/107-92b83a04ce2fab1f5914aeab2b0ae931cc4d46a7b51c84f70b6b36f3c54f782e.jpeg",
    "/photos/108-193852fbbe825577ffdcaea0d1eee1ca7e4444bd9a55e5b6dfe0aa2ded8925f7.jpeg",
    "/photos/109-5a759c9cf170bd4ffa90a2677f5935b1202095107f26ecff3a18773d21f9288b.jpeg",
    "/photos/110-33b52249c1caf8db93458339c73bd8422a94ec8575effd613b8969378eabda55.jpeg",
  ];
  const prev = () => setIndex((index + images.length - 1) % images.length);
  const next = () => setIndex((index + 1) % images.length);

  return (
    <div className="flex w-full flex-col items-center justify-center p-4">
      <div className="relative">
        <img
          src={images[index]}
          alt={`photo ${index + 1}`}
          className="mt-8 h-[85vh] rounded"
        />
      </div>
      <div className="mt-1 flex items-center gap-3">
        <button
          onClick={prev}
          className="rounded-full bg-white bg-opacity-60 p-2 transition-all hover:bg-opacity-80"
        >
          <ArrowLeft size={20} />
        </button>
        <p className="min-w-[3rem] text-center text-sm font-medium text-gray-700">
          {index + 1} / {images.length}
        </p>
        <button
          onClick={next}
          className="rounded-full bg-white bg-opacity-60 p-2 transition-all hover:bg-opacity-80"
        >
          <ArrowRight size={20} />
        </button>
      </div>
    </div>
  );
};

export default Photos;
